import { Injectable } from '@angular/core';
import {map} from 'rxjs/operators';
import {FeedApiModel} from "../models/feed.api.model";
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";
import {plainToClass, plainToClassFromExist} from "class-transformer";
import {ResultListApiModel} from "../models/result-list.api.model";
import { HttpClient, HttpResponse } from "@angular/common/http";
import {QueryParamsApiModel} from "../models/query-params-api.model";
import {QueryParamsService} from "../../core/services/query-params.service";

@Injectable({
  providedIn: 'root'
})
export class FeedRestService {
  private readonly resource: string = `/feeds`;

  constructor(
    private http: HttpClient,
    public params: QueryParamsService
  ) {
  }

  public create(feedAM: FeedApiModel): Observable<FeedApiModel> {
    return this.http.post<FeedApiModel>(environment.apiUrl + this.resource, feedAM)
      .pipe(map((result: FeedApiModel) => plainToClass(FeedApiModel, result)));
  }

  public put(feedAM: FeedApiModel): Observable<FeedApiModel> {
    return this.http.put<FeedApiModel>(environment.apiUrl + feedAM['@id'], feedAM)
      .pipe(map((result: FeedApiModel) => plainToClass(FeedApiModel, result)));
  }

  public get(feedAM: FeedApiModel): Observable<FeedApiModel> {
    return this.http.get<FeedApiModel>(environment.apiUrl+ feedAM['@id'])
      .pipe(map((result: FeedApiModel) => plainToClass(FeedApiModel, result)));
  }

  public getById(id: number): Observable<FeedApiModel> {
    return this.http.get<FeedApiModel>(environment.apiUrl+ this.resource + '/' + id)
      .pipe(map((result: FeedApiModel) => plainToClass(FeedApiModel, result)));
  }

  public getBySlug(slug: string): Observable<FeedApiModel> {
    return this.http.get<FeedApiModel>(environment.apiUrl+ this.resource + '/' + slug)
      .pipe(map((result: FeedApiModel) => plainToClass(FeedApiModel, result)));
  }

  public delete(feedAM: FeedApiModel): Observable<HttpResponse<any>> {
    return this.http.delete<HttpResponse<any>>(environment.apiUrl + feedAM['@id']);
  }

  public getCollection(queryParamsApiModel: QueryParamsApiModel = new QueryParamsApiModel(), resource: string = null): Observable<ResultListApiModel<FeedApiModel>> {
    const params = this.params.applyParameters(queryParamsApiModel);
    return this.http.get<ResultListApiModel<FeedApiModel>>(environment.apiUrl + (resource || this.resource), {params})
      .pipe(map(result => plainToClassFromExist(new ResultListApiModel<FeedApiModel>(FeedApiModel), result as object)));
  }

  public getUserSubResourceCollection(userId: string): Observable<ResultListApiModel<FeedApiModel>> {
    return this.http.get<ResultListApiModel<FeedApiModel>>(environment.apiUrl + userId + this.resource)
      .pipe(map(result => plainToClassFromExist(new ResultListApiModel<FeedApiModel>(FeedApiModel), result as object)));
  }
}
